<template>
  <div class="consultation">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%" top="8vh"
      @close="handleClose" append-to-body>
      <el-container class="container" direction="vertical">
        <el-descriptions :column="4" border>
          <template>
            <el-descriptions-item label="患者姓名" span="2">{{ lastPageForm.name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="登记号" span="2">{{ lastPageForm.recordNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="性别" span="2">{{ getGender(lastPageForm.gender) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="年龄" span="2">{{ getAge(lastPageForm.birthday) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" span="2">{{ lastPageForm.phone || '-' }}</el-descriptions-item>
          </template>
          <template>
            <el-descriptions-item label="管理标签*" span="4">
              <el-select v-if="!isAdd" v-model="form.diseaseGroup" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in manageTagsList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
              <el-input v-if="isAdd" placeholder="请输入内容" v-model="subForm.diseaseGroup"
                style="width: 220px;"></el-input>
              <el-button type="primary" style="margin-left: 10px;" @click="handleAddManageTag">{{ isAdd ? '新增' : '选择'
              }}</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="随诊建议*" span="4">
              <el-select v-model="form.followup" placeholder="请选择" style="min-width: 70%;" :disabled="isRead">
                <el-option v-for="(x, index) in followupSuggestionsList" :key="index" :label="x.label"
                  :value="x.label" />
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="复查到期时间*" span="4">
              <el-checkbox v-model="form.noReview" :disabled="isRead" style="margin-right: 12px;">不复查</el-checkbox>
              <el-date-picker type="date" placeholder="选择复查到期时间" v-model="form.reviewTime"
                :disabled="isRead || form.noReview"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="备注" span="4">
              <el-input type="textarea" placeholder="请输入内容" v-model="form.annotation" :rows="2"
                :disabled="isRead"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="手术情况" span="2">
              <el-select v-model="form.surgeryName" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in surgicalSituationList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="病理类型" span="2">
              <el-select v-model="form.pathologyName" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in pathologicalTypeList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
            </el-descriptions-item>
          </template>
          <template>
            <el-descriptions-item label="方案信息" span="4">
              <el-descriptions :column="4" border>
                <el-descriptions-item label="操作人" span="4">{{ userInfos.name || '-' }}</el-descriptions-item>
                <el-descriptions-item label="科室" span="4">{{ userInfos.deptName || '尚未建立协诊科室信息'
                }}</el-descriptions-item>
                <el-descriptions-item label="方案生成时间" span="4">{{ userInfos.codiagTime || '-' }}</el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>
          </template>
        </el-descriptions>

      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 12px;" type="primary" @click="handleClose">关闭</el-button>
        <!-- <el-button type="primary" v-if="!isRead" @click="handleSubmit">确认修改</el-button> -->

        <el-popconfirm title="是否确认提交？" @confirm="handleSubmit" v-if="!isRead">
          <el-button slot="reference" type="primary">确认修改</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCoDiagDirect, getUserInfos, getSysDicList, getlistClinicItem, getMedicineList, addIntegrateManage } from "@/api/health/Patients";
import { postAddPatientFollowupGroup, postPatientFollowupGroupsByGroupName, getCancerManagePlanByIdcard, postSaveCancerManagePlan } from "@/api/health/Lung";
export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      isRead: false,
      isModify: false,
      title: "生成管理方案",
      showDialog: false,
      isAdd: false,
      form: {
        diseaseGroup: null,
        followup: null,
        reviewTime: null,
        noReview: false,
        annotation: null,
        surgeryName: null,
        pathologyName: null,
      },
      resetForm: {
        diseaseGroup: null,
        followup: null,
        reviewTime: null,
        noReview: false,
        annotation: null,
        surgeryName: null,
        pathologyName: null,
      },
      subForm: {
        diseaseGroup: null,
      },
      lastPageForm: {},
      userInfos: {},
      sexOptions: [],
      manageTagsList: [
        { label: "高危", value: "highRisk" },
        { label: "中危", value: "mediumRisk" },
        { label: "低危", value: "lowRisk" },
        { label: "未评估", value: "notEvaluated" }
      ],
      // 随访建议
      followupSuggestionsList: [{ label: "无", value: '无' }],
      // 手术情况数据（默认固定选项）
      surgicalSituationList: [
        { label: "未手术", value: "未手术" },
        { label: "已手术", value: "已手术" }
      ],
      // 病理类型数据（默认固定选项）
      pathologicalTypeList: [
        { label: "腺癌", value: "腺癌" },
        { label: "鳞癌", value: "鳞癌" },
        { label: "小细胞肺癌", value: "小细胞肺癌" },
        { label: "大细胞肺癌", value: "大细胞肺癌" },
        { label: "其他", value: "其他" }
      ],
    }
  },
  created() {
    this.getSystemDictList('性别');
    this.getSystemDictList('肺结节协诊');
  },
  watch: {
    'form.noReview'(val) {
      if (val) {
        this.form.reviewTime = null;
      }
    }
  },
  methods: {
    async init(value) {
      this.lastPageForm = { ...value }
      this.isRead = value?.isRead;
      this.isModify = value?.isModify;
      // 目前没有 isRead
      if (this.isRead) {
        this.title = "管理方案详情";
      }
      if (this.isModify) {
        const res = await getCancerManagePlanByIdcard({ idcard: value?.idcard });
        this.title = "修改管理方案";
        this.form.diseaseGroup = res.data?.managementTag;
        this.form.followup = res.data?.followUpSuggestion;
        this.form.reviewTime = res.data?.reviewDueDate ? res.data?.reviewDueDate?.split('T')[0] : null;
        this.form.noReview = res.data?.reviewFlag === 0;
        this.form.surgeryName = res.data?.surgeryStatus;
        this.form.pathologyName = res.data?.pathologicalType;
        this.form.annotation = res.data?.remarks;
      }

      const res = await postPatientFollowupGroupsByGroupName({});
      if (res.msg === 'success') {
        this.manageTagsList = [{ label: "无", value: '无' }, ...res.data?.records?.map(x => ({
          label: x.groupName,
          value: x.groupName
        })) || []];
      }
      this.getSystemTime();
      this.showDialog = true;
      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          this.userInfos.name = res.data.name; // 医师姓名
          this.userInfos.hospitalPhone = res.data.hospitalPhone; // 电话
          this.userInfos.hospitalName = res.data.hospitalName; // 机构
          this.userInfos.deptName = res.data.deptName; // 科室
          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    /** 设置弹窗状态 */
    setDialogClosed() {
      this.showDialog = false;
    },
    /** 提交 */
    async handleSubmit() {
      if (!this.form.diseaseGroup && (!this.subForm.diseaseGroup && this.isAdd)) {
        this.$message({
          message: "请选择或添加管理标签！",
          type: "error"
        })
        return;
      }
      if (!this.form.followup) {
        this.$message({
          message: "请选择随访建议！",
          type: "error"
        })
        return;
      }
      if (!this.form.reviewTime && !this.form.noReview) {
        this.$message({
          message: "请选择复查时间！",
          type: "error"
        })
        return;
      }
      if (this.isAdd) {
        this.form.diseaseGroup = null;
        try {
          const addRes = await postAddPatientFollowupGroup({ groupName: this.subForm.diseaseGroup || '' });
          if (!addRes || addRes.msg !== 'success' || addRes.code === 500) {
            this.$message({
              message: (addRes && addRes.msg) || '新增管理标签失败！',
              type: 'error'
            });
            return; // 中断后续提交，避免继续走下去
          }
        } catch (err) {
          console.log(err);
          this.$message({
            message: err.msg || '新增管理标签失败！',
            type: 'error'
          });
          return; // 出现异常也中断后续提交
        }
      } else {
        this.subForm.diseaseGroup = null;
      }
      await postSaveCancerManagePlan({
        idcard: this.lastPageForm.idcard,
        managementTag: !this.isAdd ? this.form.diseaseGroup : this.subForm.diseaseGroup,
        followUpSuggestion: this.form.followup,
        reviewDueDate: this.form.reviewTime,
        reviewFlag: this.form.noReview ? 0 : 1,
        surgeryStatus: this.form.surgeryName,
        pathologicalType: this.form.pathologyName,
        remarks: this.form.annotation
      }).then(res => {
        if (!this.isModify) {
          addIntegrateManage({
            idcard: this.lastPageForm.idcard,
            integrateManageStatus: '已管理'
          })
        }
        if (res.msg === 'success') {
          this.$message({
            message: "管理方案提交成功！",
            type: "success"
          })
          this.$emit("upDataList");
          this.setDialogClosed();
        } else {
          this.$message({
            message: res.msg || "管理方案提交失败！",
            type: "error"
          })
        }
      }).catch(err => {
        console.log(err);
        this.$message({
          message: err.msg || "管理方案提交失败！",
          type: "error"
        })
      })
      // diseaseGroup: !this.isAdd ? this.form.diseaseGroup : this.subForm.diseaseGroup,
      // lungcanerGuideId: this.form.followup?.split('_')[0],
      // lungcanerGuide: this.form.followup?.split('_')[1],
      // reviewTime: this.form.reviewTime,
      // surgeryName: this.form.surgeryName,
      // pathologyName: this.form.pathologyName,
      // annotation: this.form.annotation
    },
    handleClose() {
      this.form = { ...this.resetForm };
      this.setDialogClosed();
    },
    handleAddManageTag() {
      this.isAdd = !this.isAdd;
      return
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        if (typeName === '性别') {
          this.sexOptions = records;
        }
        if (typeName === '肺结节协诊') {
          this.followupSuggestionsList = [...records.map(x => ({ label: x.name, value: x.value })) || []];
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);
      this.userInfos.codiagTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option?.name;
    },
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
  }

}
</script>
<style lang="scss" scoped>
.container {
  // height: 500px !important;
  overflow: auto !important;
}
</style>